"use client";

import { useContext } from 'react';

import { CognitoAuthContext } from '../lib/contexts/cognito';

export default function useCognito() {
  const context = useContext(CognitoAuthContext);

  if (!context) {
    throw new Error(
      'useCognitoAuth must be used within an CognitoAuthProvider',
    );
  }

  return context;
}
